import React from 'react'
import "./InnerBanner.css";


const InnerBanner = () => {
    return (
        <section className='InnerBanner'>
            <div className="img-holder">
                <img
                    className="ban-img"
                    src={
                        process.env.PUBLIC_URL +
                        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/banner2.png"
                    }
                />
            </div>
        </section>
    )
}

export default InnerBanner
